// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import jquery from 'jquery'
import moment from 'moment'
import accounting from 'accounting'
import router from './router'
import Cookie from 'vue-cookie'
import Resource from 'vue-resource'
import Bootstrap from 'bootstrap'
import VTooltip from 'v-tooltip'
import VueChatScroll from 'vue-chat-scroll'
import fieldCompetitor from "@/components/form/fieldCompetitor.vue"
import fieldDatetime from "@/components/form/fieldDatetime.vue"
import VueCurrencyFilter from 'vue-currency-filter'
import CripLoading from "crip-vue-loading"
import Notifications from 'vue-notification'

import { SweetModal, SweetModalTab } from 'sweet-modal-vue'
import FlagIcon from 'vue-flag-icon'
import VueTabs from 'vue-nav-tabs'
import 'vue-nav-tabs/themes/vue-tabs.css'
import VueBreadcrumbs from 'vue-breadcrumbs'
import VueLocalForage from 'vue-localforage'
import VueNotifications from 'vue-notifications'
import swal from 'sweetalert'// https://github.com/t4t5/sweetalert
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import general from '@/mixins/general'
import VueWaypoint from 'vue-waypoint'
import Sticky from 'vue-sticky-directive'
import Vuex from 'vuex'
import store from './store/store'

Vue.use(Sticky)

import VueSlideBar from 'vue-slide-bar'

Vue.component('VueSlideBar', VueSlideBar)

import CountryFlag from 'vue-country-flag'

Vue.component('country-flag', CountryFlag)

// Waypoint plugin
Vue.use(VueWaypoint);
Vue.use(general);

Vue.use(VueAwesomeSwiper);
import infiniteScroll from 'vue-infinite-scroll'
Vue.use(infiniteScroll);

Vue.use(VueTabs);
Vue.component('SweetModal', SweetModal);
Vue.component('SweetModalTab', SweetModalTab);

Vue.use(SweetModal);
Vue.use(SweetModalTab);
Vue.use(Notifications);

Vue.component("fieldCompetitor", fieldCompetitor);
Vue.component("fieldDatepicker", fieldDatetime);

Vue.use(VueChatScroll);
Vue.use(VTooltip);
Vue.directive('tooltip', VTooltip.VTooltip);

window.windowFocused = true;
/*window.scheme = 'https:';
window.apphost = '1vsbet.com';
window.api = '';
window.wsapi = 'wss://plysport.com/';
window.bsapi = 'https://sportsbook.1vsbet.com/';
window.session = new Object;
window.loading = 0;
 */

window.markets = {};
window.marketType = {}

window.scheme = 'https:';
window.search = window.scheme+'//bs.co/'
window.apphost = 'vivo90.com';
window.api = '';
window.wsapi = 'wss://plysport.com/';
window.bsapi = window.scheme+'//eu.plysport.com/';
window.session = new Object;
window.loading = 0;

//window.bsapi = window.scheme+'//sportsbook.1vsbet.com/';npn
window.envMode = 'prod';

var language = window.location.pathname.replace(/^\/([^\/]+).*/i,'$1');
window.locale = (language != '/') ? language : defaultLocale

if (process && process.env.NODE_ENV === 'development') {
    window.scheme = 'https:';
    window.envMode = 'dev';
    window.apphost = 'vivobahis.com';
    window.apphost = 'sp.co';
   // window.wsapi = 'ws://bs.co';
    window.bsapi = window.scheme+'//bs.co:99/';
    window.bsapi = 'https://eu.plysport.com/'
    window.search = 'http://bs.co/'
}

//window.locale = 'tr'
window.auth = new Object;
window.userLang = navigator.language || navigator.userLanguage;

window.accessTokenHeader = null;
Vue.use(FlagIcon);
Vue.use(VueLocalForage)
Vue.use(VueCurrencyFilter);

Vue.use(Resource)
Vue.use(Cookie)
Vue.config.productionTip = false

Vue.http.options.emulateJSON = true;

Vue.http.interceptors.push((request, next) => {

    function getCookie(name) {
        function escape(s) { return s.replace(/([.*+?\^${}()|\[\]\/\\])/g, '\\$1'); };
        var match = document.cookie.match(RegExp('(?:^|;\\s*)' + escape(name) + '=([^;]*)'));
        return match ? match[1] : null;
    }

    if(request.url.match(bsapi)) {
        request.headers.set('X-App-Session', 'Bearer '+window.auth.accessToken);
    }
    else if( !request.url.match('api/v1/get/client') && window.auth.accessToken ) {

        /*
        if (!request.params.access_token) {
            if (!request.url.match('access_token=')) {
                if (request.params != 0) {

                    request.params.access_token = window.auth.accessToken;
                }
            }
        }
        */
        if(window.auth.accessToken){
            request.headers.set('Authorization', 'Bearer '+window.auth.accessToken);
            request.headers.set('X-Token', window.auth.accessToken);
        }
            
    }
    request.headers.set('Accept-Language', window.locale);

//console.log(request);
next()
})

const EventBus = new Vue()

Object.defineProperties(Vue.prototype, {
    $bus: {
        get: function () {
            return EventBus
        }
    }
})

Vue.use(VueBreadcrumbs, {
    template: '<ul class="breadcrumb" v-if="$breadcrumbs.length"> ' +
    '<li class="breadcrumb-item"><router-link :to="{ name: \'Home\' }">{{ $root.t.navigation[\'home\'] }}</router-link></li>' +
    '<li class="breadcrumb-item" v-for="(crumb, key) in $breadcrumbs"><span v-if="$route.meta.breadcrumb == crumb.name">{{ $root.t.navigation[crumb.name.toLowerCase()] }}</span><router-link :to="linkProp(crumb)" :key="key" v-if="$route.meta.breadcrumb != crumb.name">{{ $root.t.navigation[crumb.name.toLowerCase()] }}</router-link></li> ' +
    '</ul>'
});

function toast ({title, message, type, timeout, cb}) {
    if (type === VueNotifications.types.warn) type = 'warning'
    return swal(title, message, type)
}

const options = {
    success: toast,
    error: toast,
    info: toast,
    warn: toast
}

Vue.use(VueNotifications, options)

/* eslint-disable no-new */
var vm = new Vue({
  el: '#app',
  store,
  router,
    data: {
        moment: moment
    },
  template: '<App />',
  components: { App },
  methods: {

  }
})

Number.prototype.formatMoney = function(c, d, t){
    var n = this,
        c = isNaN(c = Math.abs(c)) ? 2 : c,
        d = d == undefined ? "." : d,
        t = t == undefined ? "," : t,
        s = n < 0 ? "-" : "",
        i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
        j = (j = i.length) > 3 ? j % 3 : 0;
    return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
};

var mixin = {
    methods: {
        refreshPage () {

            setTimeout(() => {
                window.location.reload()
            }, 500)
        },
        getLastXMonths () {
            const today = new Date();
            let lastSixMonths = []

            var locale = window.navigator.userLanguage || window.navigator.language;
            moment.locale(locale);

            for (var i = 6; i > -1; i -= 1) {
                const date = new Date(today.getFullYear(), today.getMonth() - i, 1);
                lastSixMonths.push({name: moment(date).format("MMMM YYYY"), date: moment(date).format("YYYY-MM-DD")})
            }

            return lastSixMonths.reverse()
        },
        partition(array, size) {
            var results = [];
            while (array.length) {
                results.push(array.splice(0, size));
            }
            return results;
        },
        globalLoader (load) {
              window.loading = load;
        },
        findByKeyAndRemove (source, key, id) {
            for (var i = 0; i < source.length; i++) {
                if (source[i][key] === id) {
                    source.splice(key, 1);
                }
            }
            return false;
        },
        findByKeyAndReplace (source, key, id, data) {
            for (var i = 0; i < source.length; i++) {
                if (source[i][key] === id) {
                    source[i] = data;
                }else {
                    source.push(data);
                }
            }
            return false;
        },
        findByKey (source, key, find) {
            for (var i = 0; i < source.length; i++) {
                if (source[i][key] === find) {
                    return source[i];
                }
            }
            return false;
        },
        abortAllRequest() {
            $.xhrPool = [];
            $.xhrPool.abortAll = function() {
                _.each(this, function(jqXHR) {
                    jqXHR.abort();
                });
            };
            $.ajaxSetup({
                beforeSend: function(jqXHR) {
                    $.xhrPool.push(jqXHR);
                }
            });
        },
        uformat (str, args) {

            if(args && str){
                for (var key in args) {
                    str = str.replace(new RegExp("\\%" + key + "\\%", "gi"), args[key]);
                }
            }

            return str;
        },
        dateTimeFormat (date) {
            return window.moment(date).format(session.date_time_format, { trim: false })
        },
        dateNow () {
            var myDate = new Date();
            var myDate_string = myDate.toISOString();
            var myDate_string = myDate_string.replace("T"," ");
            var myDate_string = myDate_string.substring(0, myDate_string.length - 5);
            return myDate_string;
        },
        objectToArray (object) {
            var x = [];
            for( var i in object ) {
                x[i] = object[i];
            }
            return x;
        },
        sortByKey(array, key) {
            var array = Object.values(array);
            return array.sort(function(a, b) {
                var x = a[key]; var y = b[key];
                return ((x < y) ? 1 : ((x > y) ? -1 : 0));
            });
        },
        sortAByKey(array, key) {
            var array = Object.values(array);
            return array.sort(function(a, b) {
                var x = a[key]; var y = b[key];
                return ((x > y) ? 1 : ((x < y) ? -1 : 0));
            });
        },
        getCookie () {
            function escape(s) { return s.replace(/([.*+?\^${}()|\[\]\/\\])/g, '\\$1'); };
            var match = document.cookie.match(RegExp('(?:^|;\\s*)' + escape(name) + '=([^;]*)'));
            return match ? match[1] : null;
        },
        logout () {
            this.$bus.$emit('globalLoader',1);
            this.$setItem('auth', {});
            window.location.href = '/';
        },
        periodTimer (m) {

            if(m.periodTimeLeft != 0){

                return m.periodTimeLeft;

            }else if(m.periodTime > 0){

                var min = (parseInt((m.periodTime / 60).toFixed(0)) + 1);

                if(m.resultName == "1st half" && m.periodTime >= 2700)
                    return "45' +"+Math.abs(45 - min);

                if(m.resultName == "2nd half" && m.periodTime >= 5400)
                    return "90' +"+Math.abs(90 - min);

                return (min > 0) ? min+"'" : '';
            }

            if(m.periodCounter > 0){
                const min = (m.roundCounter / 3600).toFixed(2);

                return (min > 0) ? min+"'" : '';
            }
        },
        timer (date) {
            // Set the date we're counting down to
            var countDownDate = new Date(date).getTime();

            // Get todays date and time
            var now = new Date().getTime();

            // Find the distance between now an the count down date
            var distance = countDownDate - now;

            // Time calculations for days, hours, minutes and seconds
            var days = Math.floor(distance / (1000 * 60 * 60 * 24));
            var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            var seconds = Math.floor((distance % (1000 * 60)) / 1000);

            // Display the result in the element with id="demo"

            return moment(date).fromNow(true);

        },
        getIpInfo () {
            return this.$http.get('http://ip-api.com/json/?fields=16510975')
        },
        fixBodyScroll () {
            setTimeout( () => {
                document.body.style.overflow='auto';
            },  600);
        }
    },
    filters: {
        toHHMMSS: function (a,p, r) {
            if (r == 18 || r == 7) {
                return ' ';
            }
            var now = Math.round(+new Date()/1000);

            var seconds = (moment(a).unix() - moment.unix(p));

            var pt = moment().diff(moment.unix(a), 'minutes')

            var add = (r != 13) ? 45 : 0;
            // 1

            return (add + moment.unix(now).diff(moment.unix(a), 'minutes') ) + "'" ;

        },
        uformat: function (str, args) {

            args.forEach(myFunction)

            for (var a in args) {
                str = str.replace(new RegExp("\\%" + a.key + "\\%", "gi"), a);
            }
            return unescape(str);
        },
        toMoney: function (val,currency,symbol = true) {


            let formatConfig = "%s %v"
            if (currency.position === 'before'){
                formatConfig = "%s %v";
            } else {
                formatConfig = "%v %s";
            }

            var mony = accounting.formatMoney(val, {
                format:  formatConfig,
                symbol: currency.symbol,
                precision : 2,
                thousand : '.',
                decimal : ',',
            });

            if(currency.position == 'before'){
                if(symbol) {
                    return mony;
                }else {
                    return currency.iso_code+' '+mony;
                }
            }else {
                if(symbol) {
                    return mony;
                }else {
                    return mony+' '+currency.iso_code;
                }
            }


        },
        moment: function (date,format,tz) {

            if(tz === undefined || tz === null) {
                var zone_name =  window.moment.tz.guess();
                var timezone = window.moment.tz(zone_name).zoneAbbr()

                var tz = timezone;
            }

            if(format === 'undefined' || format === null) {
                var format = 'M/D/Y HH:mm:ss';
            }
            if(date){
                return (format && tz) ? window.moment(date).format(format, { trim: false }) : date;
            }
        },
        tz: function (dt,tz,format,ago = true) {
            window.moment.tz.add(tz)
            if(ago){
                return (dt && tz) ? window.moment(dt).fromNow() : '--'; // 5 years ago
            }else {
                return (dt && tz) ? window.moment(dt).format(format, { trim: false }) : '--'; // 5 years ago
            }
        },
        timeAgo: function (dt) {
            //window.moment.tz.add(window.session.date_time_format);
            return (dt) ? window.moment(dt).fromNow() : '';
        },
        slimiter: function(str, limit) {
            return (limit && str.length > limit) ? str.substring(0,limit)+'...' : str;
        },
        nPlus: function (number) {
            return (number > 90) ? '90+' : number;
        },
        arrayFragmentation: function (Array, n = 6) {
            var count = Array.length;
            var newArray = new Array();

            for(i = 0; i <= count;) {
                newArray[i] = Array.slice(i, n);
                i++;
            }
        },
    }
}

Vue.mixin(mixin);

Array.prototype.remByVal = function(val) {
    for (var i = 0; i < this.length; i++) {
        if (this[i] === val) {
            this.splice(i, 1);
            i--;
        }
    }
    return this;
}


// WEBPACK FOOTER //
// ./src/main.js